export default function NotFoundPage() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-bold">404</h1>
      <p className="text-gray-600 mt-2">Page not found.</p>
    </div>
  );
}
